import { FilterInfo } from './types';
import { MapBoundsParams } from '../api/camps';

/**
 * Builds query parameters from filters and map bounds.
 * This consolidates the duplicated logic previously in useFilterCamps,
 * useGetCampsWithBounds, and useGetMapPoints.
 */
export function buildFilterParams(
  filters: FilterInfo,
  bounds: MapBoundsParams | null,
): Record<string, any> {
  const queryParams: Record<string, any> = {};

  // Add bounds parameters
  if (bounds) {
    queryParams.ne_lat = bounds.ne_lat;
    queryParams.ne_lng = bounds.ne_lng;
    queryParams.sw_lat = bounds.sw_lat;
    queryParams.sw_lng = bounds.sw_lng;
    if (bounds.zoom !== null)
      queryParams.zoom = Math.floor(bounds.zoom);
  }

  // Add filter parameters
  if (filters.activity_keywords && filters.activity_keywords.length > 0) {
    queryParams.activity_keywords = filters.activity_keywords;
  }
  if (filters.ages && filters.ages.length > 0) {
    queryParams.ages = filters.ages;
  }
  if (filters.start_date) {
    queryParams.start_date = filters.start_date;
  }
  if (filters.end_date) {
    queryParams.end_date = filters.end_date;
  }
  if (filters.organizer_id) {
    queryParams.organizer_id = filters.organizer_id;
  }
  if (filters.duration) {
    queryParams.duration = filters.duration;
  }
  if (filters.min_price) {
    queryParams.min_price = filters.min_price;
  }
  if (filters.max_price) {
    queryParams.max_price = filters.max_price;
  }
  if (filters.min_rating) {
    queryParams.min_rating = filters.min_rating;
  }

  return queryParams;
}
